export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: "/dashboard/login",
  },
  DASHBOARD: {
    KPI: "/dashboard/kpi",
  },
};
